<div class="reporter-dialog">
  <div class="list-scroller">
    <ol>
      @for (report of reports; track report) {
        <li class="report">
          <nom-error-list-item [report]="report" (dismissed)="dismissOne.emit($event)"></nom-error-list-item>
        </li>
      }
    </ol>
  </div>
  <div class="copy-region">
    @if (copyText) {
      <div class="copy-field">
        <input type="text" class="copy-text" (click)="select($event)" [value]="copyText">
        <button class="dismiss-copy-button" (click)="dismissCopy.emit()">
          Done
        </button>
      </div>
    }
  </div>
  <div class="actions">
    <button
      type="button"
      class="dismiss-all-button"
      (click)="dismissAll.emit()"
      title="Dismiss every report in this list"
      >
      Dismiss all
    </button>
    <div class="spacer"></div>
    <button
      type="button"
      class="copy-all-history-button"
      (click)="copyAllHistory.emit()"
      title="Copy every report that's ever shown up here, including ones you've dismissed"
      >
      Copy history
    </button>
    <button
      type="button"
      class="copy-all-button"
      (click)="copyAll.emit()"
      title="Copy everything you see here"
      >
      Copy all
    </button>
  </div>
</div>
